import service from '../utils/request';

export function searchMaterialPreparationOrders(params) {
  const requestParams = {
    current: params.current || 1,
    size: params.size || 20,
    planStatus: params.status || '',
    emergencyLevel: params.emergencyLevel || ''
  };
  
  // 根据搜索类型设置不同的搜索参数
  if (params.searchType && params.keyword) {
    switch (params.searchType) {
      case 'orderNo':
        requestParams.orderNo = params.keyword;
        break;
      case 'supplierName':
        requestParams.supplierName = params.keyword;
        break;
      case 'materialNo':
        requestParams.materialNo = params.keyword;
        break;
      default:
        requestParams.orderNo = params.keyword;
    }
  } else if (params.keyword) {
    // 兼容旧的搜索方式
    requestParams.orderNo = params.keyword;
  }
  
  return service.get('/uic-system_hf/materialPreparation/mobliePage', {
    params: requestParams
  });
}

export function updateMaterialPreparationStatus(id, status, actualNum) {
  const requestData = {
    id,
    planStatus: status
  };
  
  // 如果提供了实际数量，添加到请求数据中
  if (actualNum !== undefined && actualNum !== null) {
    requestData.actualNum = actualNum;
  }
  
  return service.post('/uic-system_hf/materialPreparation/updateStatus', requestData);
}

// 获取用户列表
export function getUsersList(params) {
  return service.get('/uic-user/page', {
    params: {
      current: params.current || 1,
      size: params.size || 20
    }
  });
}

// 分配备料任务
export function distributePreparationTask(id, operatorId) {
  return service.post(`/uic-system_hf/materialPreparation/distribute/operator?ids=${id}&materialOperator=${operatorId}`);
}

// PLS备料发送日志
export function sendPlsLog(params) {
  return service.get('/uic-system_hf/wareout/page', { params });
}

// 获取物料库存
export function getStock(materialStock) {
  return service.get('/uic-system/hf_materialstock/getStock', {
    params: materialStock
  });
}

// 更新物料备料状态
export function updateMaterialStatus(wareOutDetailId) {
  return service.post('/uic-system_hf/wareoutdetail/updateStatus', wareOutDetailId);
}

// 查询物料状态
export function getMaterialStatus (id) {
  return service.get(`/uic-system_hf/wareoutdetail/getMaterialStatus/${id}`); 
}


// 分配备料用户
export function allocationUser(wareOutId, userId) {
  return service.post('/uic-system_hf/wareoutdetail/allocationUser', {
    wareOutId: wareOutId,
    materialOperator: userId
  });
}